import authService from '@/services/authService';
import { Spin } from 'antd';
import axios from 'axios';
import React from 'react';

export default function AuthImage({ src, ...props }: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  const [imageSrc, setImageSrc] = React.useState<string>();
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (src) {
      setLoading(true);

      axios
        .get(src || '', {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${authService.getAccessToken()}`,
          },
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'image/jpeg' });
          const imageUrl = URL.createObjectURL(blob);
          setImageSrc(imageUrl);
        })
        .catch(window.console.error)
        .finally(() => {
          setLoading(false);
        });
    }
  }, [src]);

  return <Spin spinning={loading}>{src ? <img alt="img" {...props} src={imageSrc} /> : null}</Spin>;
}
